export async function downloadImagem(url, nomeArquivo) {
    if (!url) return;

    const nomeFinal = nomeArquivo || extrairNomeDaUrl(url) || `imagem-${Date.now()}.jpg`;

    try {
        const response = await fetch(url, { mode: 'cors' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = nomeFinal;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    } catch (_) {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
}

function extrairNomeDaUrl(url) {
    try {
        const pathname = new URL(url).pathname;
        const ultimo = pathname.split('/').filter(Boolean).pop();
        return ultimo && ultimo.includes('.') ? ultimo : null;
    } catch {
        return null;
    }
}
